import i18next from 'i18n';

export default function Error() {
    return (
        <div className="container mx-auto p-8">
            <h2>{i18next.t('general.something-went-wrong')}</h2>
        </div>
    );
}
